import React, { useEffect, useState, useRef } from "react";
import QRCode from "qrcode";
import close from "../../assets/close.png";
import content_copy from "../../assets/content_copy.png";
import green_check from "../../assets/green_check.png";
import email from "../../assets/email.png";
import facebook from "../../assets/facebook.png";
import message from "../../assets/message.png";
import "../../css/SharePopup.css";
import { Rating } from "./Rating";

function SharePopup({ setShowSharePopup, company }) {
    const smallQRCodeRef = useRef(null);
    const largeQRCodeRef = useRef(null);
    const [copyLinkIcon, setCopyLinkIcon] = useState(content_copy);
    const [enlargeQRCode, setEnlargeQRCode] = useState(false);
    const [copyLinkText, setCopyLinkText] = useState("Copy Link");

    useEffect(() => {
        if (typeof window !== "undefined") {
            const currentURL = window.location.href;
            const smallCanvas = smallQRCodeRef.current;
            const largeCanvas = largeQRCodeRef.current;
            const smallCanvasCtx = smallCanvas.getContext('2d');
            const largeCanvasCtx = largeCanvas.getContext('2d');

            QRCode.toCanvas(smallCanvas, currentURL, { width: 75 }, (err) => {
                if (err) {
                    console.error(err);
                    return;
                }

                const logo = new Image();
                logo.src = "https://res.cloudinary.com/dv9z6ctwz/image/upload/v1738124605/basic-bigger-closer-view-enlarge-icon_obxazs.svg";
                logo.onload = () => {
                    const logoSize = 25;
                    const padding = 3;
                    const x = (smallCanvas.width - logoSize) / 2;
                    const y = (smallCanvas.height - logoSize) / 2;

                    smallCanvasCtx.fillStyle = "#fff";
                    smallCanvasCtx.fillRect(x - padding, y - padding, logoSize + padding * 2, logoSize + padding * 2);

                    smallCanvasCtx.drawImage(logo, x, y, logoSize, logoSize);
                };
            });

            QRCode.toCanvas(largeCanvas, currentURL, { width: 300 }, (err) => {
                if (err) {
                    console.error(err);
                    return;
                }

                const logo = new Image();
                logo.src = "https://res.cloudinary.com/dv9z6ctwz/image/upload/v1736464954/qrcode_logo_g7imh8.png";
                logo.onload = () => {
                    const logoSize = 60;
                    const padding = 5;
                    const x = (largeCanvas.width - logoSize) / 2;
                    const y = (largeCanvas.height - logoSize) / 2;

                    largeCanvasCtx.fillStyle = "#fff";
                    largeCanvasCtx.fillRect(x - padding, y - padding, logoSize + padding * 2, logoSize + padding * 2);

                    largeCanvasCtx.drawImage(logo, x, y, logoSize, logoSize);
                };
            });

            largeCanvas.style.margin = "0 auto";
        }
    }, []);

    const handleOutsideClick = (e) => {
        if (e.target.classList.contains("sharePopupContainer")) {
            setShowSharePopup(false);
        }
    };

    const handleCopyLinkClick = async () => {
        try {
            const currentUrl = window.location.href;
            await navigator.clipboard.writeText(currentUrl);
            setCopyLinkIcon(green_check);
            setCopyLinkText("Link Copied");

            setTimeout(() => {
                setCopyLinkIcon(content_copy);
                setCopyLinkText("Copy Link");
            }, 2000);
        } catch (err) {
            console.error("Failed to copy URL to clipboard:", err);
        }
    };

    const handleEmailClick = () => {
        const currentUrl = window.location.href;
        const subject = encodeURIComponent(`Check out this business: ${company.name}`);
        const body = encodeURIComponent(`I thought you might be interested in this business: ${company.name}. Here's the link: ${currentUrl}`);
        window.open(`mailto:?subject=${subject}&body=${body}`, "_self");
    };

    const handleMessagesClick = () => {
        const currentUrl = window.location.href;
        const message = `Check out this business: ${company.name}. Here's the link: ${currentUrl}`;
        if (navigator.share) {
            navigator
                .share({
                    title: `Check out this business: ${company.name}`,
                    text: message,
                    url: currentUrl,
                })
                .catch((err) => console.error("Sharing failed:", err));
        } else {
            alert("Sorry, your browser doesn't support direct sharing.");
        }
    };

    const handleFacebookClick = () => {
        const currentUrl = encodeURIComponent(window.location.href);
        const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;
        window.open(facebookShareUrl, "_blank");
    };

    const handleCloseClick = () => {
        setShowSharePopup(false);
    };

    return (
        <div className="sharePopupContainer" onClick={handleOutsideClick}>
            <div className="sharePopupWrap">
                <div className="sharePopupCloseButton" onClick={handleCloseClick}>
                    <img src={close || ""} alt="[close]" />
                </div>
                <div className="sharePopupTitle">Share this business</div>
                <div className="sharePopupDescription">
                    <canvas className={"sharePopupQRCodeContainer" + (enlargeQRCode ? " hidden" : "")} ref={smallQRCodeRef}
                            onClick={() => setEnlargeQRCode(true)}/>
                    <canvas className={"sharePopupQRCodeContainer" + (enlargeQRCode ? "" : " hidden")} ref={largeQRCodeRef}
                            onClick={() => setEnlargeQRCode(false)}/>
                    <div className={"sharePopupDetailsContainer" + (enlargeQRCode ? " hidden" : "")}>
                        <div className="sharePopupCompanyName">{company.name}</div>
                        <div className="sharePopupRatingsContainer">
                            <Rating
                                score={company.yelp_rating}
                                reviews={company.yelp_count}
                                url={company.yelp_url}
                                platform="Yelp"
                            />
                            <Rating
                                score={company.google_rating}
                                reviews={company.google_count}
                                url={company.google_url}
                                platform="Google"
                            />
                        </div>
                    </div>
                </div>
                <div className="sharePopupShareButtonsContainer">
                    <div className="sharePopupShareButton" onClick={handleCopyLinkClick}>
                        <div className="sharePopupShareButtonContent">
                            <div className="sharePopupShareButtonIcon">
                                <img src={copyLinkIcon || ""} alt="Copy Link"
                                     className="sharePopupShareButtonIconImage"/>
                            </div>
                            <div className="sharePopupShareButtonText">{copyLinkText}</div>
                        </div>
                    </div>
                    <div className="sharePopupShareButton" onClick={handleEmailClick}>
                        <div className="sharePopupShareButtonContent">
                            <div className="sharePopupShareButtonIcon">
                                <img src={email || ""} alt="Email" className="sharePopupShareButtonIconImage"/>
                            </div>
                            <div className="sharePopupShareButtonText">Email</div>
                        </div>
                    </div>
                    <div className="sharePopupShareButton" onClick={handleMessagesClick}>
                        <div className="sharePopupShareButtonContent">
                            <div className="sharePopupShareButtonIcon">
                                <img src={message || ""} alt="Message" className="sharePopupShareButtonIconImage"/>
                            </div>
                            <div className="sharePopupShareButtonText">Messages</div>
                        </div>
                    </div>
                    <div className="sharePopupShareButton" onClick={handleFacebookClick}>
                        <div className="sharePopupShareButtonContent">
                            <div className="sharePopupShareButtonIcon">
                                <img src={facebook || ""} alt="Facebook" className="sharePopupShareButtonIconImage"/>
                            </div>
                            <div className="sharePopupShareButtonText">Facebook</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SharePopup;
